import { createEntityPickerField } from "./createEntityPickerField";
import type { TypedEntityPickerProps } from "./EntityPickerField";
import type { GroupId } from "../../api/types";

export type GroupPickerFieldProps = TypedEntityPickerProps<GroupId>;

export const GroupPickerField = createEntityPickerField<GroupId>("group");
